export default __webpack_public_path__ + "static/media/hermit_knight.ec37d7e2.png";